module.exports = __webpack_public_path__ + "public/files/img/result.0a34196d.gif";